import React from "react";
import { useSelector } from "react-redux";

import Footer from "../../components/Footer";
import SectionHeader from "../../components/SectionHeader";
import baseLogo from "../../images/logo.png";

const FeatureList = () => {
  const session = useSelector(state => state.auth.session);
  const logo = session?.options?.logo ?? baseLogo;

  return (
    <div className="flex min-h-screen flex-col bg-white">
      <SectionHeader logo={logo} />
      <main className="flex flex-col space-y-8 p-4 md:p-8">
        <div className="mb-8 space-y-4 md:space-y-0 md:space-x-4 lg:p-8">
          <h5 className="my-4 text-center text-3xl font-medium md:text-3xl">
            Powerful B2B Features
          </h5>
          <p className="mt-8 text-base text-gray-600 md:text-lg">
            Shopping is increasingly becoming mobile. In growing economies like
            China and India, mobile is the primary device to access the
            internet.{" "}
            <span className="text-indigo-400">
              By 2021, about 73% of global ecommerce sales is expected to happen
              on mobile.
            </span>{" "}
            Bharatmart is built from a mobile-first market in India. All the
            major features can be used from the mobile app. Why use a PC when
            you can run your whole business conveniently from the phone?
          </p>
        </div>

        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6">
            <div className="mb-8 transform rounded-lg bg-white shadow-lg transition-transform hover:scale-105">
              <div className="relative flex items-center justify-between rounded-t-lg bg-blue-600 px-5 py-3 text-white">
                <span className="text-sm font-semibold md:text-base">
                  Onboard
                </span>
                <div className="absolute top-1/2 right-0 h-0 w-0 -translate-y-1/2 translate-x-1/2 transform border-t-8 border-b-8 border-l-8 border-t-transparent border-b-transparent border-l-blue-600"></div>
              </div>
              <div className="p-4 md:p-6">
                <div className="mb-3 text-xs text-purple-600 hover:underline md:text-sm">
                  <a href="#upload">Product Upload</a>
                </div>
                <div className="text-xs text-purple-600 hover:underline md:text-sm">
                  <a href="#buyer-addition">Buyer Addition</a>
                </div>
              </div>
            </div>
            <div className="mb-8 transform rounded-lg bg-white shadow-lg transition-transform hover:scale-105">
              <div className="relative flex items-center justify-between rounded-t-lg bg-blue-500 px-5 py-3 text-white">
                <span className="text-sm font-semibold md:text-base">
                  Manage Orders
                </span>
                <div className="absolute top-1/2 right-0 h-0 w-0 -translate-y-1/2 translate-x-1/2 transform border-t-8 border-b-8 border-l-8 border-t-transparent border-b-transparent border-l-blue-500"></div>
              </div>
              <div className="p-4 md:p-6">
                <div className="mb-3 text-xs font-bold text-black md:text-sm">
                  Buyer
                </div>
                <div className="mb-3 text-xs text-purple-600 hover:underline md:text-sm">
                  <a href="#placing-order">Placing an Order</a>
                </div>
                <div className="mb-3 text-xs font-bold text-black md:text-sm">
                  Seller
                </div>
                <div className="mb-3 text-xs text-purple-600 hover:underline md:text-sm">
                  <a href="#customer-orders">
                    Your sales staff can take orders from customers
                  </a>
                </div>
                <div className="mb-3 text-xs text-purple-600 hover:underline md:text-sm">
                  <a href="#process-order">Process Order</a>
                </div>
                <div className="text-xs text-purple-600 hover:underline md:text-sm">
                  <a href="#manage-supply-chain">
                    Manage orders in your whole supply chain
                  </a>
                </div>
              </div>
            </div>
            <div className="mb-8 transform rounded-lg bg-white shadow-lg transition-transform hover:scale-105">
              <div className="relative flex items-center justify-between rounded-t-lg bg-blue-400 px-5 py-3 text-white">
                <span className="text-sm font-semibold md:text-base">
                  Deliver Goods
                </span>
                <div className="absolute top-1/2 right-0 h-0 w-0 -translate-y-1/2 translate-x-1/2 transform border-t-8 border-b-8 border-l-8 border-t-transparent border-b-transparent border-l-blue-400"></div>
              </div>
              <div className="p-4 md:p-6">
                <div className="mb-3 text-xs font-bold text-black md:text-sm">
                  Using third party logistics
                </div>
                <div className="mb-3 text-xs text-purple-600 hover:underline md:text-sm">
                  <a href="#choose-courier">Choose the courier & ship</a>
                </div>
                <div className="mb-3 text-xs font-bold text-black md:text-sm">
                  Using own Logistics
                </div>
                <div className="text-xs text-purple-600 hover:underline md:text-sm">
                  <a href="#router-optimisation">
                    Route optimize, assign & ship
                  </a>
                </div>
              </div>
            </div>
            <div className="mb-8 transform rounded-lg bg-white shadow-lg transition-transform hover:scale-105">
              <div className="relative flex items-center justify-between rounded-t-lg bg-blue-300 px-5 py-3 text-white">
                <span className="text-sm font-semibold md:text-base">
                  Analytics & CRM
                </span>
              </div>
              <div className="p-4 md:p-6">
                <div className="mb-3 text-xs font-bold text-black md:text-sm">
                  Analytics
                </div>
                <div className="mb-3 text-xs text-purple-600 hover:underline md:text-sm">
                  <a href="#chat">Chat</a>
                </div>
                <div className="mb-3 text-xs text-purple-600 hover:underline md:text-sm">
                  <a href="#crm">CRM</a>
                </div>
                <div className="text-xs text-purple-600 hover:underline md:text-sm">
                  <a href="#analytics">Analytics & Reporting</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <section className="py-4">
          <div className="flex flex-col items-center">
            <div className="text-3xl font-medium">Onboard</div>
            <div className="my-2 w-24 border-b border-gray-300" />
          </div>
          <div className="container mx-auto">
            <div
              id="upload"
              className="my-4 flex flex-col items-center justify-between border-b border-gray-300 pb-4 md:flex-row">
              <div className="flex w-full flex-col p-2 md:w-1/2">
                <div className="text-lg font-semibold">Product Upload</div>
              </div>

              <div className="flex w-full flex-col p-2 md:w-1/2">
                <p className="text-gray-600">
                  Upload your inventory either one at a time or in bulk. Doing
                  it on mobile is as simple as making a Facebook post.
                </p>
              </div>

              <div className="flex w-full justify-center p-2 md:w-1/2">
                <img
                  src="https://res.cloudinary.com/prokure/image/upload/v1540175894/websiteData/upload_3x.png"
                  className="h-auto max-h-40 w-full object-contain"
                />
              </div>
            </div>
            <div
              id="buyer-addition"
              className="my-4 flex flex-col items-center justify-between border-b border-gray-300 pb-4 md:flex-row">
              <div className="flex w-full flex-col p-2 md:w-1/2">
                <div className="text-lg font-semibold">Buyer Addition</div>
              </div>

              <div className="flex w-full flex-col p-2 md:w-1/2">
                <p className="text-gray-600">
                  Add all your customers in one go. Shifting all your customers
                  to a new business platform cannot get easier than this.
                </p>
              </div>

              <div className="flex w-full justify-center p-2 md:w-1/2">
                <img
                  src="https://res.cloudinary.com/prokure/image/upload/v1540175893/websiteData/buyer-addition_3x.png"
                  className="h-auto max-h-40 w-full object-contain"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="py-4">
          <div className="flex flex-col items-center">
            <div className="text-3xl font-medium">Manage Orders</div>
            <div className="my-2 w-24 border-b border-gray-300" />
          </div>
          <div className="container mx-auto">
            <div className="flex w-full flex-col p-2 md:my-16 md:w-1/2">
              <div className="text-4xl font-medium">Buyer</div>
            </div>
            <div
              id="placing-order"
              className="my-4 flex flex-col items-center justify-between border-b border-gray-300 pb-4 md:flex-row">
              <div className="flex w-full flex-col p-2 md:w-1/2">
                <div className="text-lg font-semibold">Placing an Order</div>
              </div>

              <div className="flex w-full flex-col p-2 md:w-1/2">
                <p className="text-gray-600">
                  No more of those mundane B2B sourcing processes. Placing an
                  order is as simple as placing an order in Amazon. All this,
                  while the complex B2B pricing and supply chain logics are
                  taken care of in the backend.
                </p>
              </div>

              <div className="flex w-full justify-center p-2 md:w-1/2">
                <img
                  src="https://res.cloudinary.com/prokure/image/upload/v1540175895/websiteData/placinf-an-prder_3x.png"
                  className="h-auto max-h-40 w-full object-contain"
                />
              </div>
            </div>
            <div className="flex w-full flex-col p-2 md:my-16 md:w-1/2">
              <div className="text-4xl font-medium">Seller</div>
            </div>
            <div
              id="customer-orders"
              className="my-4 flex flex-col items-center justify-between border-b border-gray-300 pb-4 md:flex-row">
              <div className="flex w-full flex-col p-2 md:w-1/2">
                <div className="text-lg font-semibold">
                  Your sales staff can take orders from customers
                </div>
              </div>

              <div className="flex w-full flex-col p-2 md:w-1/2">
                <p className="text-gray-600">
                  Logged in as a sales staff, they can take orders from your
                  customers in the app
                </p>
              </div>

              <div className="flex w-full justify-center p-2 md:w-1/2"></div>
            </div>

            <div
              id="process-order"
              className="my-4 flex flex-col items-center justify-between border-b border-gray-300 pb-4 md:flex-row">
              <div className="flex w-full flex-col p-2 md:w-1/2">
                <div className="text-lg font-semibold">Process Order</div>
              </div>

              <div className="flex w-full flex-col p-2 md:w-1/2">
                <p className="text-gray-600">
                  Confirm, reject, edit, allot it to different warehouses, all
                  of it can happen with a couple of clicks. Easier if done from
                  the mobile app.
                </p>
              </div>

              <div className="flex w-full justify-center p-2 md:w-1/2">
                <img
                  src="https://res.cloudinary.com/prokure/image/upload/v1540175895/websiteData/prcess-order_3x.png"
                  className="h-auto max-h-40 w-full object-contain"
                />
              </div>
            </div>
            <div
              id="manage-supply-chain"
              className="my-4 flex flex-col items-center justify-between border-b border-gray-300 pb-4 md:flex-row">
              <div className="flex w-full flex-col p-2 md:w-1/2">
                <div className="text-lg font-semibold">
                  Manage orders in your whole supply chain
                </div>
              </div>

              <div className="flex w-full flex-col p-2 md:w-1/2">
                <p className="text-gray-600">
                  Do you want to manually allot orders to different sellers in
                  your supply chain? Should your sellers be able to control the
                  product prices? Take complete control of the order flow in
                  your supply chain
                </p>
              </div>

              <div className="flex w-full justify-center p-2 md:w-1/2">
                <img
                  src="https://res.cloudinary.com/prokure/image/upload/v1540175895/websiteData/manage_3x.png"
                  className="h-auto max-h-40 w-full object-contain"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="py-4">
          <div className="flex flex-col items-center">
            <div className="text-3xl font-medium">Analysis & CRM</div>
            <div className="my-2 w-24 border-b border-gray-300" />
          </div>
          <div className="container mx-auto">
            <div
              id="chat"
              className="my-4 flex flex-col items-center justify-between border-b border-gray-300 pb-4 md:flex-row">
              <div className="flex w-full flex-col p-2 md:w-1/2">
                <div className="text-lg font-semibold">Chat</div>
              </div>

              <div className="flex w-full flex-col p-2 md:w-1/2">
                <p className="text-gray-600">
                  Chat with all your customers. Share products and offers with
                  them in chat, answer their queries. All your business chat in
                  one place.
                </p>
              </div>

              <div className="flex w-full justify-center p-2 md:w-1/2">
                <img
                  src="https://res.cloudinary.com/prokure/image/upload/v1540175893/websiteData/chat_3x.png"
                  className="h-auto max-h-40 w-full object-contain"
                />
              </div>
            </div>
            <div
              id="crm"
              className="my-4 flex flex-col items-center justify-between border-b border-gray-300 pb-4 md:flex-row">
              <div className="flex w-full flex-col p-2 md:w-1/2">
                <div className="text-lg font-semibold">CRM</div>
              </div>

              <div className="flex w-full flex-col p-2 md:w-1/2">
                <p className="text-gray-600">
                  All your customer relationship metrics in one place. High
                  value customers, churned customers, Most frequent buyers etc.
                  With the inbuilt chat, you can reach out to them too.
                </p>
              </div>

              <div className="flex w-full justify-center p-2 md:w-1/2">
                <img
                  src="https://res.cloudinary.com/prokure/image/upload/v1540175893/websiteData/crm_3x.png"
                  className="h-auto max-h-40 w-full object-contain"
                />
              </div>
            </div>
            <div
              id="analytics"
              className="my-4 flex flex-col items-center justify-between border-b border-gray-300 pb-4 md:flex-row">
              <div className="flex w-full flex-col p-2 md:w-1/2">
                <div className="text-lg font-semibold">
                  Analytics & Reporting
                </div>
              </div>

              <div className="flex w-full flex-col p-2 md:w-1/2">
                <p className="text-gray-600">
                  Detailed analytics of your business metrics. Slice and dice
                  all your business data to any granularity according to your
                  needs. Built using Druid and Superset.
                </p>
              </div>

              <div className="flex w-full justify-center p-2 md:w-1/2">
                <img
                  src="https://res.cloudinary.com/prokure/image/upload/v1540175893/websiteData/crm_3x.png"
                  className="h-auto max-h-40 w-full object-contain"
                />
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default FeatureList;
